import React, { useEffect, useState } from 'react';

function Faq({ filter }) {
    const [faq, setFaq] = useState([])

    useEffect(() => {
        getFaq()
    }, [])


    const getFaq = () => {
        fetch(`${document.apiURL}/home/faq`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            },
        })
            .then(response => response.json())
            .then(response => {
                setFaq(response.filter(q => q.context === filter))
            });
    }

    return (<>
        {faq.map((e) =>
            <details key={JSON.stringify(e)} className="card-faq pointer">
                <summary className="text-card-faq">{e.question}</summary>
                <h4 className="text-card-faq">{e.answer}</h4>
            </details>


        )}</>
    );
}


export default Faq;